import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const REDIRECT_QUERY_PARAM = 'redirect';

export function isSafeInternalRedirectPath(path: string): boolean {
  return path.startsWith('/') && !path.startsWith('//');
}

export const RedirectQueryParamGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const redirect = route.queryParamMap.get(REDIRECT_QUERY_PARAM);
  if (redirect && isSafeInternalRedirectPath(redirect)) {
    return router.parseUrl(redirect);
  }
  return true;
};
